/**
 * 結果サマリーの「ランキング（参考）」表示用の算出。（モック用仮実装。本番ではモックとは別の算出ロジックを使用）
 * 正答率が 100% の場合は 1%、80% 以上は 20%、60% 以上は 40%、40% 以上は 60%、それ以下は 80% とする。
 * 試用ユーザーの場合は null を返す。
 * 正答率が 80% 以上の場合は 20%、60% 以上の場合は 40%、それ以下は null を返す。
 * 正答率が 80% 以上の場合は 20%、60% 以上の場合は 40%、それ以下は null を返す。
 */

/** 正答率（0–100）から内部パーセンタイル用の段階値（1,20,40,60,80）へ変換 */
export function getRankingPercentFromScore(percentage: number): number {
  if (percentage >= 100) return 1;
  if (percentage >= 80) return 20;
  if (percentage >= 60) return 40;
  if (percentage >= 40) return 60;
  return 80;
}

/** 表示は上位20%・上位40%のみ（それ以外・試用ユーザーは null） */
export function getDisplayRankingTier(
  correctAnswerPercentage: number,
  isTrialUser: boolean,
): 20 | 40 | null {
  if (isTrialUser) return null;
  const rankingPercent = getRankingPercentFromScore(correctAnswerPercentage);
  if (rankingPercent > 40) return null;
  return rankingPercent <= 20 ? 20 : 40;
}

export function getRankingTierComment(tier: 20 | 40): string {
  if (tier === 20) return 'トップクラスです！';
  return 'かなり上位です！';
}

/**
 * APIから取得したランキング情報からコメントを生成する
 * @param tier ランキングのtier（20, 40, または null）
 * @param _totalUsers 参加者総数（現在は未使用だが、将来の拡張用に残す）
 * @returns 表示するコメント
 */
export function getRankingCommentFromApi(
  tier: 20 | 40 | null,
  _totalUsers: number,
): string {
  // tierに応じたメッセージ
  if (tier === 20) {
    return 'トップクラスです！';
  }
  if (tier === 40) {
    return 'かなり上位です！';
  }
  
  // tier が null の場合（上位20%、40%に入らない）
  return 'またの参加をお待ちしております';
}
